import React, { Component, createRef } from 'react';
import { Splide, SplideSlide } from '@splidejs/react-splide';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import CommonUtil from '../../../../utils/commonUtil';
import { getProductRecommendations } from '../actions';

const channel = CommonUtil.getChannel();
const brand = CommonUtil.getBrand();
const isWap = channel === 'wap';

@connect(
  (store) => ({
    lables: store.labels.data,
  }),
  {
    getProductRecommendations,
  },
)
class ProductRecommendationCarousel extends Component {
  constructor(props) {
    super(props);

    this.splideRef = createRef();

    this.breakpoint_map = {
      desktop: 1024,
      tablet: 600,
      mobile: 480,
    };
  }

  componentDidMount() {
    const { component, getProductRecommendations } = this.props;

    const payload = {
      channel: channel,
      brand: brand,
      categoryId: component?.category_id || '',
    };

    getProductRecommendations(payload);
  }

  getSplideOptions() {
    const { component } = this.props;

    const splideSettings = {
      responsive:
        component?.carousel_settings?.responsive?.map((r) => {
          const { device, ...rest } = r;
          return {
            breakpoint: this.breakpoint_map[r.device],
            settings: rest,
          };
        }) || [],
    };

    const defaultSettings = splideSettings.responsive.find(
      (r) => r.breakpoint === 1024,
    )?.settings;

    return {
      ...defaultSettings,
      autoScroll: {
        ...defaultSettings?.autoscroll?.[0],
        pauseOnHover: defaultSettings?.autoscroll?.[0]?.pauseonhover,
        pauseOnFocus: defaultSettings?.autoscroll?.[0]?.pauseonfocus,
      },
    };
  }

  render() {
    const { component, productRecommendationResponse } = this.props;

    const products = productRecommendationResponse || [];

    if (!products || products.length === 0) {
      return null;
    }

    const splideOptions = this.getSplideOptions();

    return (
      <div id='product-recommendation-carousel'>
        <div className='recommended'>
          <div className='recommended__header'>
            <h2 className='recommended__title'>{component?.carousel_title}</h2>

            {/* <div className='recommended__view-more'>
              <span>Ver más</span>
              <div className='arrow-right' />
            </div> */}
          </div>

          <div
            className='wrapper'
            style={{ backgroundColor: component?.background_color }}
          >
            <div className='carousel'>
              <Splide
                options={splideOptions}
                key={window.location.pathname}
                aria-label={component?.title}
                ref={this.splideRef}
              >
                {products.map((product, index) => (
                  <SplideSlide key={index}>
                    <ProductCard
                      index={index}
                      product={product}
                      isWap={isWap}
                    />
                  </SplideSlide>
                ))}
              </Splide>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const splitPrice = (value) => {
  const str = String(value).trim();

  const match = str.match(/^(\D?)([\d,]+)(?:\.(\d+))?$/);
  if (!match) {
    return {
      currency: '$',
      integer: '0',
      decimal: '00',
    };
  }

  const currency = match[1] || '';
  const rawIntegerPart = match[2].replace(/,/g, '');
  const decimalPart = match[3] || '00';

  const formattedInt = Number(rawIntegerPart).toLocaleString();

  return {
    currency,
    integer: formattedInt,
    decimal: decimalPart.padEnd(2, '0'),
  };
};

const ProductCard = ({ index, product, isWap }) => {
  const listPrice = splitPrice(
    CommonUtil.getCurrency(product?.price?.listPrice),
  );
  const salePrice = splitPrice(
    CommonUtil.getCurrency(product?.price?.salePrice),
  );

  const samePrice = product?.price?.listPrice === product?.price?.salePrice;

  const image =
    product?.image?.mobile?.src ||
    product?.image?.tablet?.src ||
    product?.image?.desktop?.src ||
    '';

  return (
    <div key={index} className='product-card'>
      <div className='product-card__image-wrapper'>
        <img
          src={image}
          alt={product?.title}
          className='product-card__image'
          width={isWap ? 140 : 220}
          height={isWap ? 182 : 294}
        />

        {product?.has_gift && (
          <div className='product-card__badge'>Regalo con compra</div>
        )}
      </div>

      <div className='product-card__info'>
        <p className='product-card__title'>{product?.title}</p>

        <div className='product-card__prices'>
          <div className='price current'>
            <span>{salePrice?.currency}</span>
            <span>{salePrice?.integer}</span>
            <span className='decimal_price'>{salePrice?.decimal}</span>
          </div>
          {!samePrice && (
            <div className='price old'>
              <span>{listPrice?.currency}</span>
              <span>{listPrice?.integer}</span>
              <span className='decimal_price'>{listPrice?.decimal}</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  productRecommendationResponse:
    state.marketingContentSection.productRecommendationResponse,
});

const matchDispatchToProps = (dispatch) =>
  bindActionCreators({ getProductRecommendations }, dispatch);

export default connect(
  mapStateToProps,
  matchDispatchToProps,
)(ProductRecommendationCarousel);
